<template>
  <v-dialog persistent v-model="showDialog" max-width="320px">
    <v-card flat>
      <v-icon class="close" @click.prevent="closeModal">$sl-close</v-icon>
      <h2>{{ title }}</h2>

      <v-card flat width="144px">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFromDate"
              :label="$t('labels.from')"
              @blur="date = parseDate(dateFromDate)"
              v-on="on"
              outlined
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-card>
      <v-card flat width="144px">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateToDate"
              :label="$t('labels.to')"
              outlined
              @blur="date1 = parseDate(dateToDate)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date1" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-card>
      <div class="d-flex justify-space-between mt-n2">
        <ActionButton          
          :block="false"
          type="application"
          actionIcon="$sl-cancel"
          @click="closeModal"
        >{{ $t('labels.cancel') }}</ActionButton>
        <ActionButton
          :block="false"
          actionIcon="$sl-clock"          
          @click="saveDates()"
          :isDisabled="isImitatingUser()"
        >{{savebtn}}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import ActionButton from '@/components/Common/ActionButton'

// @group Common
// Styled FromDateToDatePicker component
export default {
  name: 'FromDateToDatePicker',
  props: {
    // Props
    // Show defines to show or not to show the modal based on Boolean

    //has from date
    fromDate: {
      // `String`
      type: String,
      // The default value is: ` '' `
      default: ''
    },
    //has to date
    toDate: {
      // `String`
      type: String,
      // The default value is: ` '' `
      default: ''
    },
    //has title
    title: {
      // `String`
      type: String,
      // The default value is: ` function representing title string`
      default: function () {
        return this.$t('ebook.change-period')
      }
    },
    // icon in the left of the title
    icon: {
      // `String`
      type: String,
      // The default value is: ` '' `
      default: ''
    },
    // outlined , used inside v-select , Boolean
    //has outlined
    outlined: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: true
    },
    // save button title
    savebtn: {
      // `String`
      type: String,
      // The default value is: ` function representing title string`
      default: function () {
        return this.$t('labels.change')
      }
    },
    // cancel button title
    cancelBtn: {
      // `String`
      type: String,
      // The default value is: ` function representing title string`
      default: function () {
        return this.$t('labels.cancel')
      }
    }
  },
  components: {
    ActionButton
  },
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    dateFromDate: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateToDate: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    showDialog: true
  }),

  watch: {
    date(val) {
      this.dateFromDate = this.formatDate(this.date)
    },
    date1(val) {
      this.dateToDate = this.formatDate(this.date1)
    }
  },

  computed: {
    ...mapGetters('currentuser', ['isImitatingUser']),
  },

  created() {
    if (this.fromDate === null && this.toDate === null) {
      this.date = new Date().toISOString().substr(0, 10)
      this.date1 = new Date().toISOString().substr(0, 10)
    }
    if (this.fromDate === null) {
      this.date = null
    } else {
      this.date = new Date(this.fromDate).toISOString().substr(0, 10)
    }
    if (this.toDate === null) {
      this.date1 = null
    } else {
      this.date1 = new Date(this.toDate).toISOString().substr(0, 10)
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}-${month}-${day}`
    },
    parseDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    /**
     * @vuese
     * Used to close modal and emit a value
     */
    closeModal() {
      // Fire close event
      // @arg The argument is a boolean and close the modal
      this.$emit('close', false)
    },
    /**
     * @vuese
     * Used to emit the new dates selected if any
     */
    saveDates() {
      if (this.dateFromDate === null) {
        this.$events.fire('showError', this.$t('error.missing-date'))
        return
      }
      if (this.dateFromDate > this.dateToDate) {
        this.$events.fire('showError', this.$t('error.oldDate'))
        return
      }
      let newDates = {newFromdate: this.dateFromDate, newTodate: this.dateToDate, close: false}
      this.showDialog = false
      // Fire datesSelected
      // @arg The argument is a string represtenting new dates
      this.$emit('datesSelected', newDates)
    }
  }
}
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: flex-end;
}
</style>